const CURRENCIES = {
  GBP: {
    SYMBOL: '£',
    ENTITY: '&pound;'
  },
  EUR: {
    SYMBOL: '€',
    ENTITY: '&euro;'
  }
};

export function getCurrencySymbol(currency = 'GBP') {
  const { SYMBOL } = CURRENCIES[currency];

  return SYMBOL;
}

export function getFormattedPriceValue(amount, divideBy100 = true) {
  if (divideBy100) {
    return (amount / 100).toFixed(2);
  }

  return (amount).toFixed(2);
}

export function addSymbolToString(amount, currency = 'GBP') {
  const { SYMBOL, ENTITY } = CURRENCIES[currency];

  const result = amount.replace(ENTITY, SYMBOL);

  return result.indexOf(SYMBOL) < 0
    ? `${SYMBOL}${result}`
    : result;
}

/**
 * Formats price received from API
 * @param {number|string} amount Price as received from the API.
 * (price integer or string - if currency sign is missing it will be added)
 * @param {bool} dividePriceBy100 price in case of number type should be divided by 100.
 * @param {string} currency in case of different currency than pound.
 * That's here because in New Checkout they receives price multiplied by 100 from backend
 * @returns {string} Price formatted to two decimals with the pound sign
 */
export default function formatPrice(amount, dividePriceBy100 = true, currency = 'GBP') {
  if (typeof amount === 'string') {
    return addSymbolToString(amount, currency);
  }

  return `${getCurrencySymbol(currency)}${getFormattedPriceValue(amount, dividePriceBy100)}`;
}
